import { clientFor } from '@yc/api-client'

const api = clientFor('/dsp/api')

/** 工作台 KPI：与后端 internal/home/service.go 的 Stats 的 JSON 字段一一对应 */
export interface HomeStats {
  /** 待调度任务数 */
  pending_tasks: number
  /** 其中加急的条数 */
  urgent_pending: number
  /** 可派的空闲车辆数 */
  idle_vehicles: number
  /** 等待发车的行车任务数 */
  planned_trips: number
  /** 在途的行车任务数 */
  running_trips: number
  /** 今天创建的行车任务数 */
  today_trips: number
}

export const getHomeStats = (): Promise<HomeStats> => api.get<HomeStats>('/home/stats')
